export enum ClaimPerPersonPanelDataTestIds {
    counter = 'pcl-claim-per-person-counter',
}

export const COUNTER_NAME_CONCAT_CHARACTER = '/';

export const MAX_COUNTER_WIDTH = '48%';
